import React from 'react';
import PropTypes from 'prop-types';
import Button from '@johnlewispartnership/wtr-ingredients/dist/Button';
const FeedbackButton = ({ icon, dataTest, label, onClick }) => {
    const buttonProps = {
        startIcon: icon,
        label,
        onClick,
        'aria-describedby': 'customerFeedbackTitle',
        'data-testid': dataTest,
        theme: 'secondary',
        displayAsLink: true,
    };
    return React.createElement(Button, Object.assign({}, buttonProps));
};
FeedbackButton.displayName = 'FeedbackButton';
FeedbackButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    dataTest: PropTypes.string.isRequired,
    icon: PropTypes.node.isRequired,
};
export default FeedbackButton;
//# sourceMappingURL=index.js.map